import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { ROOT } from "./config/consumerEngagement.route";
import ConsumerEngagementReport from "./consumerEngagementReport";
import { disbursementReducer } from "./redux";

export default function LuckyDrawModule() {
  return (
    <Switch>
      <Route exact path={ROOT} component={ConsumerEngagementReport} />
      <Route path="*">
        <Redirect to="/admin/invalid" />
      </Route>
    </Switch>
  );
}

export { ROOT, disbursementReducer };
